module.exports = __webpack_public_path__ + "img/temp-blog-01b.b1e6cf82.jpg";